import React from 'react';
import { Clock } from './clock';
import { getRaceTime } from '../../../services/time';

export const RaceClock = () => (
    <Clock timeFn={getRaceTime} />
);

